import React, { useEffect, useState } from "react";
import SeoHelmet from "@/components/SeoHelmet";
import seoConfig from "@/data/seo.config";
import TermsAndConditionsBuyerSupplier from "@/modules/frontend/components/Terms_And_Conditions/TermsAndConditionsBuyerSupplier";
import TermsAndConditionsLogistic from "@/modules/frontend/components/Terms_And_Conditions/TermsAndConditionsLogistic";
// import TermsAndConditionsBuyer from "@/modules/frontend/components/Terms_And_Conditions/TermsAndConditionsBuyer";
// import TermsAndConditionsSupplier from "@/modules/frontend/components/Terms_And_Conditions/TermsAndConditionsSupplier";
import { Tab, Tabs } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import ConsentManager from "@/modules/frontend/components/ConsentManager";
import { motion } from "framer-motion";

const Index = () => {

  const fadeUpVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: (delay = 0) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, delay },
    }),
  };

  const navigate = useNavigate();
  const location = useLocation();

  const [pageTitle, setpageTitle] = useState("Terms And Conditions");

  // Mapping URL paths to tab keys
  const tabMap = {
    "/terms-and-conditions-buyer-supplier": "1",
    "/terms-and-conditions-logistic": "2",
    // "/terms-and-conditions-buyer": "3",
    // "/terms-and-conditions-logistic": "4",
  };

  // Reverse map for setting URL from tab selection

  const reverseTabMap = {
    1: "/terms-and-conditions-buyer-supplier",
    2: "/terms-and-conditions-logistic",
    // 3: "/terms-and-conditions-buyer",
    // 4: "/terms-and-conditions-logistic",
  };

  const activeKey = tabMap[location.pathname] || "1";

  const handleSelect = (key) => {
    navigate(reverseTabMap[key]); // Update the browser URL
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {

    if (location.pathname === "/terms-and-conditions-buyer-supplier") {
      setpageTitle("Buyer/Supplier Terms And Conditions");
    }

    else if (location.pathname === "/terms-and-conditions-logistic") {
      setpageTitle("Logistic Partner Terms and Conditions");
    }

  }, [location.pathname]);

  return (
    <section className="terms-and-condition-wraper">
      {
        (location.pathname === "/terms-and-conditions-buyer-supplier") && <SeoHelmet
          title={seoConfig.termsAndConditionsBuyerSupplier.title}
          description={seoConfig.termsAndConditionsBuyerSupplier.description}
          keywords={seoConfig.termsAndConditionsBuyerSupplier.keywords}
          author={seoConfig.termsAndConditionsBuyerSupplier.author}
        />
      }
      {
        (location.pathname === "/terms-and-conditions-logistic") && <SeoHelmet
          title={seoConfig.termsAndConditionsLogistic.title}
          description={seoConfig.termsAndConditionsLogistic.description}
          keywords={seoConfig.termsAndConditionsLogistic.keywords}
          author={seoConfig.termsAndConditionsLogistic.author}
        />
      }

      {/* <section className="inner-pad page contact-us-wrape">
        <section className="inner-banner-wrape global-advertising terms-condition banner-wrape">
          <div className="inner"> {pageTitle}</div>
          <span class="sprite decoration"></span>
        </section>
      </section> */}

      {/* inner banner wrape START  */}
      <div className="inner-banner">
        <div className="container">
          <div className="content-wrape desk-hide">
            <motion.h2 className="animate-child"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              custom={0.2}
              variants={fadeUpVariant}
            >
              <span className="light">
                Terms And
              </span>&nbsp;
              <span className="blue">
                Conditions
              </span>
            </motion.h2>
            <motion.p
              className="animate-child"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              custom={0.2}
              variants={fadeUpVariant}
            >These terms outline your rights and responsibilities as an OrexTrade user.</motion.p>
          </div>
          {/* <div className="content-wrape">
              <h1>{pageTitle}</h1>
            </div> */}
        </div>
      </div>
      {/* inner banner wrape END  */}

      <div className=" trem-of-service-wraper container">
        <div className=" inner-page-content-wrape">
          <div className="content-wrape mobile-show page-head ">
            <motion.h2 className="mobile-head-text animate-child"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              custom={0.2}
              variants={fadeUpVariant}
            >
              <span className="light">Terms And</span>&nbsp;
              <span className="blue-text"> Conditions</span>
            </motion.h2>
            <motion.p className="animate-child"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              custom={0.2}
              variants={fadeUpVariant}
            >These terms outline your rights and responsibilities as an OrexTrade user.</motion.p>
          </div>
        </div>

        <Tabs
          defaultActiveKey={1}
          activeKey={activeKey}
          onSelect={handleSelect}
          id="uncontrolled-tab-example"
          className="term-of-tab-wraper"
        >
          <Tab eventKey={1} title="Terms and Conditions Buyer/Supplier">
            <TermsAndConditionsBuyerSupplier />
          </Tab>

          <Tab eventKey={2} title="Terms and Conditions Logistics">
            <TermsAndConditionsLogistic />
          </Tab>

          {/* <Tab eventKey={3} title="Terms and Conditions Buyer">
            <TermsAndConditionsBuyer />
          </Tab> */}

          {/* <Tab eventKey={4} title="Terms and Conditions logistic">
            <TermsAndConditionsLogistic />
          </Tab> */}
        </Tabs>
      </div>
      <ConsentManager data={""} />
    </section>
  );
}

export default Index;
